var map = {
	"./1000+.png": 161,
	"./404.png": 162,
	"./BookReader.png": 163,
	"./Booknet.png": 164,
	"./BravoFiction.png": 165,
	"./CamelNovel.png": 166,
	"./Chapters.png": 167,
	"./CoralReader.png": 168,
	"./CornReading.png": 169,
	"./DailyBooks.png": 170,
	"./DeerFiction.png": 171,
	"./DolphinReader.png": 172,
	"./Dreams.png": 173,
	"./FICTLF.png": 174,
	"./FancyNovel.png": 175,
	"./FicFun.png": 176,
	"./FictionFlow.png": 177,
	"./FoxFics.png": 178,
	"./FoxFm.png": 179,
	"./Free2Read.png": 180,
	"./FreeRead.png": 181,
	"./FunFic.png": 182,
	"./FunNovel.png": 183,
	"./Gonovel.png": 184,
	"./GoodFiction.png": 185,
	"./GoodStory.png": 186,
	"./GoodToon.png": 187,
	"./GrapeNovel.png": 188,
	"./HippoNovel.png": 189,
	"./HitNovel.png": 190,
	"./HotNovel.png": 191,
	"./IHear.png": 192,
	"./KiWiReader.png": 193,
	"./Kiwi.png": 194,
	"./LetsRead.png": 195,
	"./Libfic.png": 196,
	"./Liby.png": 197,
	"./LionFiction.png": 198,
	"./Listenow.png": 199,
	"./LoveNovel.png": 200,
	"./LoveRead.png": 201,
	"./Mango.png": 202,
	"./MangoReader.png": 203,
	"./Mobooks.png": 204,
	"./Monkey.png": 205,
	"./MyNovel.png": 206,
	"./NovelFox.png": 207,
	"./NovelNow.png": 208,
	"./NovelWorld.png": 209,
	"./NovelZone.png": 210,
	"./Octopus.png": 211,
	"./OrangeReader.png": 212,
	"./OwlReader.png": 213,
	"./PocketeBooks.png": 214,
	"./PocketeReader.png": 215,
	"./Pocketoons.png": 216,
	"./Podfic.png": 217,
	"./PopFic.png": 218,
	"./PopNovel.png": 219,
	"./PopStories.png": 220,
	"./Pumpkin.png": 221,
	"./Rabbit.png": 222,
	"./Read4Fun-ios.png": 223,
	"./Read4Fun.png": 224,
	"./ReadNow.png": 225,
	"./Readify.png": 226,
	"./Readme.png": 227,
	"./Seagull.png": 228,
	"./Sealread.png": 229,
	"./SharkNovels.png": 230,
	"./Shepherd.png": 231,
	"./SnailReads.png": 232,
	"./StarfishFiction.png": 233,
	"./StoryHouse.png": 234,
	"./StoryRover.png": 235,
	"./StorySpot.png": 236,
	"./SuperFiction.png": 237,
	"./SuperNovel.png": 238,
	"./Sweet.png": 239,
	"./TaleTrek.png": 240,
	"./TapRead.png": 241,
	"./Tellstory.png": 242,
	"./TigerReader.png": 243,
	"./Tomato.png": 244,
	"./TopFic.png": 245,
	"./Topicks.png": 246,
	"./VampireNovels.png": 247,
	"./WeJoy.png": 248,
	"./WeRead.png": 249,
	"./Webfiction.png": 250,
	"./Webfm.png": 251,
	"./Webnovel.png": 252,
	"./Webstories.png": 253,
	"./Whatstory.png": 254,
	"./about_bg.png": 255,
	"./android-FicFun.png": 256,
	"./appStore-check.png": 257,
	"./appStore.png": 69,
	"./application.png": 258,
	"./banner.png": 259,
	"./banner1.png": 260,
	"./banner2.png": 261,
	"./banner3.png": 262,
	"./basic.png": 263,
	"./bg-game.png": 264,
	"./bg.png": 265,
	"./book.png": 266,
	"./bottom-icon.png": 267,
	"./cherryfiction.png": 268,
	"./close.png": 269,
	"./contact_bg.png": 270,
	"./desc.png": 271,
	"./down (1).png": 272,
	"./down.png": 273,
	"./e1.png": 274,
	"./e2.png": 275,
	"./e3.png": 276,
	"./eAudioBooks.png": 277,
	"./eReader-logo.png": 278,
	"./ereader.png": 279,
	"./ficfun-logo.png": 280,
	"./fj.png": 281,
	"./form_bg.png": 282,
	"./funtel-logo.png": 283,
	"./funtel.png": 284,
	"./goodfic.png": 285,
	"./googlePlay-check.png": 286,
	"./googlePlay.png": 70,
	"./greatnovel.png": 287,
	"./i1.png": 288,
	"./i2.png": 289,
	"./i3.png": 290,
	"./iAudios.png": 291,
	"./iNovel-ios.png": 292,
	"./iNovel.png": 293,
	"./iRomance.png": 294,
	"./iToons.png": 295,
	"./icon.png": 296,
	"./infinitytale.png": 297,
	"./iosGoodStory.png": 298,
	"./iosgoodfiction.png": 299,
	"./left.png": 300,
	"./litchifiction.png": 301,
	"./logo.png": 302,
	"./logo2.png": 303,
	"./logo3.png": 304,
	"./logo4.png": 305,
	"./logo5.png": 306,
	"./m-tel.png": 307,
	"./more.png": 308,
	"./pandareads.png": 309,
	"./peanutnovel.png": 310,
	"./phone.png": 118,
	"./pocketEbook.png": 311,
	"./qiandao.png": 312,
	"./redfic.png": 313,
	"./right.png": 314,
	"./right_bg.png": 315,
	"./romancestories.png": 316,
	"./storyfm.png": 317,
	"./theme3/shu.png": 119,
	"./theme4/banner.png": 120,
	"./theme4/people.png": 121,
	"./topstories.png": 318,
	"./ty.png": 319,
	"./web-logo.png": 320,
	"./werewolfnovels.png": 321,
	"./whatsread.png": 322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;